import { useEffect, useState } from 'react';

export const formatElapsed = (sec: number): string => {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
  if (m > 0) return `${m}m ${String(s).padStart(2, '0')}s`;
  return `${s}s`;
};

export const useElapsedSeconds = (startMs: number | undefined, running: boolean): number => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!running || startMs === undefined) return;
    const tick = () => setElapsed(Math.max(0, Math.floor((Date.now() - startMs) / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => {
      clearInterval(id);
      setElapsed(0);
    };
  }, [running, startMs]);

  return elapsed;
};
